import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import Search from './search';
import UserIdentity from './user-identity';

class Header extends Component {
  constructor(props){
    super(props);
  }

  componentWillReceiveProps(newProps){
    if(this.props === newProps) { return; }
    this.props = newProps;
  }
  
  render(){
    return (
      <div className="header">
        <span>
          <Link className="header-link" to="/">
            <img src="/assets/images/logo.png" className="logo" />
              CSI Help System
          </Link>
        </span>
        {(this.props.isAuthenticated === true) ? 
          <div className="admin-mode-banner">Administration Mode</div> :
          <Search />
        }
        <UserIdentity isAuthenticated={this.props.isAuthenticated} />
      </div>
    );
  }
}

export default Header;